import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeNavMenu } from '../features/NavMenu';
import { closeSearchBar } from '../features/SearchBar';

const Backdrop = ({ headerHeight }) => {
  const navMenu = useSelector((state) => state.navMenu.value);
  const searchBar = useSelector((state) => state.searchBar.value);
  const dispatch = useDispatch();
  return (
    <>
      {navMenu.isOpen || searchBar.isOpen ? (
        <div
          className={`z-20 glass fixed inset-0`}
          style={{ marginTop: `${headerHeight}px` }}
          onClick={() => {
            dispatch(closeNavMenu());
            dispatch(closeSearchBar());
          }}
        >
        </div>
      ) : null}
    </>
  );
};

export default Backdrop;
